import * as React from 'react';
import NormalizeProgress from '../Normalizacion/NormalizeProgress';
import Layout from '../components/Utilities/Layout';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import FeatureManager from '../components/Utilities/FeatureManager';

export default class Home extends React.Component<{}, {}> {
    public constructor(props: {}) {
        super(props);
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Normalizaciones} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.Normalizaciones} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Normalizaciones',
                                url: ''
                            }
                        ]
                    }>
                        
                            <NormalizeProgress/>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }
}